module.exports = __webpack_public_path__ + "static/img/application.28d05057.jpg";